import React from 'react'
import "./backdrop.scss";

export const Backdrop =
    ({ onClick }) => {
    return ( 
        <div
            className={`bsw-backdrop-container ${!onClick ? 'bsw-backdrop-container__static' : ''}`}
            onClick={onClick}
        />
    )
}
